export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "contextWorker.4886f252.worker.js");
}
